import { render, staticRenderFns } from "./ChatEmotion.vue?vue&type=template&id=aff84d8e&scoped=true"
import script from "./ChatEmotion.vue?vue&type=script&lang=js"
export * from "./ChatEmotion.vue?vue&type=script&lang=js"
import style0 from "./ChatEmotion.vue?vue&type=style&index=0&id=aff84d8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff84d8e",
  null
  
)

export default component.exports